import styled from 'styled-components';
import { CaptionBoldL } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface INoDataCont {
  theme: ITheme;
  height?: string;
}

export const NoDataCont = styled(CaptionBoldL)<INoDataCont>`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  ${({ theme, height }: INoDataCont) => `
    color:  ${theme.colors.neutral.primary[80]};
    height: ${height ? height : '200px'};
  `};
`;
